




































import axios from 'axios';
import { User } from '../../models/user';

import { Component, Prop, Vue } from 'vue-property-decorator';

import { userWebservice } from '../../webservices/user';

@Component
export default class Login extends Vue {

    // Data
    private user: User = {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
        password_confirmation: '',
        phone_number: '',
    };

    private disabled: boolean = false;
    private errorMsg: string = '';


    // Methods
    private login() {
        if (this.user.email === '' || this.user.password === '') {
            this.errorMsg = 'Die Emailadresse oder das Passwort fehlt.';
            return;
        }

        userWebservice.login(this.user.email, this.user.password).then((response) => {
            this.errorMsg = '';
            this.$store.commit('account/setApiToken', response.data.api_token);

            userWebservice.getUserInfo().then((responseUser) => {
                this.$store.commit('account/setCurrentUser', responseUser.data);
            });
        }).catch((error) => {
            this.errorMsg = 'Das Passwort oder der Benutzername sind nicht korrekt';
            console.log(error);
        });
    }
}
